export const formatLoanName = (loan) => {
  if (loan?.loanName) {
    return loan.loanName;
  }

  if (loan?.loanNumber) {
    return `Loan #${loan.loanNumber}`;
  }
  return "N/A";
};
